module.exports = __webpack_public_path__ + "static/media/boss-bar-yellow-04.5617fa28.png";